/* Kamaya Atelier — theme behaviour (no dependencies) */
(function () {
  'use strict';
  var K = window.Kamaya || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var root = (K.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Overlays (menu, cart) ---------- */
  var lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeOverlay(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeOverlay($('[data-cart-drawer]')); closeOverlay($('[data-mobile-menu]')); }
  });

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header && header.classList.contains('site-header--overlay')) {
      var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    var menu = $('[data-mobile-menu]');
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openOverlay(menu); b.setAttribute('aria-expanded', 'true'); }); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closeOverlay(menu); $$('[data-menu-open]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); }); }); });

    var bar = $('[data-search-bar]');
    $$('[data-search-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!bar) return;
        e.preventDefault();
        bar.hidden = !bar.hidden;
        if (header) header.classList.add('is-solid');
        if (!bar.hidden) $('input[type="search"]', bar).focus();
      });
    });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { bar.hidden = true; }); });

    $$('[data-theme-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('kamaya-theme', next); } catch (e) {}
      });
    });
  }

  /* ---------- Autosubmit selects (filters, sort, localization) ---------- */
  function initAutosubmit() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-autosubmit]')) {
        var form = t.form;
        if (form.hasAttribute('data-collection-filters')) {
          // drop empty params so URLs stay clean
          var params = new URLSearchParams(new FormData(form));
          var clean = new URLSearchParams();
          params.forEach(function (v, k) { if (v !== '' && k !== 'q') clean.append(k, v); });
          window.location.search = clean.toString();
        } else {
          form.submit();
        }
      }
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (show) {
      var slides = $$('[data-slide]', show);
      var dots = $$('[data-slide-to]', show);
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var seconds = parseInt(show.getAttribute('data-autoplay'), 10) || 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function play() { stop(); if (seconds > 0) timer = setInterval(function () { go(i + 1); }, seconds * 1000); }
      function stop() { if (timer) clearInterval(timer); }
      var rtl = document.documentElement.dir === 'rtl';
      var prev = $('[data-slide-prev]', show), next = $('[data-slide-next]', show);
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); play(); }); });
      var x0 = null;
      show.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      show.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(i + ((dx < 0) !== rtl ? 1 : -1));
        x0 = null; play();
      });
      show.addEventListener('mouseenter', stop);
      show.addEventListener('mouseleave', play);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
      // Theme editor: show selected block
      document.addEventListener('shopify:block:select', function (e) {
        var idx = slides.indexOf(e.target);
        if (idx > -1) { stop(); go(idx); }
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    $$('[data-media-id]', gallery).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(mediaId)); });
    $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(mediaId)); });
  }
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      $$('[data-thumb]', g).forEach(function (t) { t.addEventListener('click', function () { showMedia(g, t.getAttribute('data-thumb')); }); });
    });
  }

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
    catch (e) { return fmt + ' ' + (cents / 100).toFixed(2); }
  }

  /* ---------- Product form ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var section = form.closest('[data-product-section]');
      var variantsEl = $('[data-variants]', form);
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var idInput = $('[data-variant-id]', form);
      var addBtn = $('[data-add-button]', form);
      var addLabel = $('[data-add-label]', form);
      var qtyInput = $('input[name="quantity"]', form);

      $$('[data-qty-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
          qtyInput.value = v;
        });
      });

      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var selected = $$('fieldset', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var match = variants.find(function (v) { return v.options.every(function (o, idx) { return o === selected[idx]; }); });
        if (!match) { addBtn.disabled = true; addLabel.textContent = K.strings.soldOut; return; }
        idInput.value = match.id;
        addBtn.disabled = !match.available;
        addLabel.textContent = match.available ? K.strings.addToCart + ' — ' + money(match.price) : K.strings.soldOut;
        if (match.featured_media) showMedia($('[data-gallery]', section), match.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = $('[data-form-error]', form);
        if (err) err.hidden = true;
        addBtn.disabled = true;
        addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }])
          .catch(function (msg) { if (err) { err.textContent = msg; err.hidden = false; } })
          .then(function () { addBtn.disabled = false; });
      });
    });
  }

  /* ---------- Cart ---------- */
  var drawerSectionId = 'cart-drawer';
  function renderDrawer(html) {
    var drawer = $('[data-cart-drawer]');
    if (!drawer || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = $('[data-cart-drawer]', tmp);
    if (!fresh) return;
    var wasOpen = !drawer.hidden;
    drawer.innerHTML = fresh.innerHTML;
    drawer.hidden = !wasOpen;
    bindDrawer();
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
  }
  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: drawerSectionId })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw (d.description || d.message || K.strings.error); return d; }); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections[drawerSectionId]);
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        openOverlay($('[data-cart-drawer]'));
      })
      .catch(function (msg) { toast(typeof msg === 'string' ? msg : K.strings.error); throw msg; });
  }
  function changeLine(line, qty) {
    var drawer = $('[data-cart-drawer]');
    drawer.classList.add('is-busy');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: drawerSectionId })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderDrawer(cart.sections[drawerSectionId]);
        if (typeof cart.item_count === 'number') updateCount(cart.item_count);
      })
      .catch(function () { toast(K.strings.error); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  function bindDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    $$('[data-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { closeOverlay(drawer); }); });
    $$('[data-line-change]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(parseInt(b.getAttribute('data-line-change'), 10), Math.max(0, parseInt(b.getAttribute('data-qty'), 10))); });
    });
  }
  function initCart() {
    bindDrawer();
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        openOverlay($('[data-cart-drawer]'));
      });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-quick-add]');
      if (!b) return;
      e.preventDefault();
      b.classList.add('is-loading');
      addToCart([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }])
        .catch(function () {})
        .then(function () { b.classList.remove('is-loading'); });
    });
  }

  /* ---------- Wishlist (stored on this device) ---------- */
  var WL_KEY = 'kamaya-wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function wlSet(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }
  function wlRefresh() {
    var list = wlGet();
    $$('[data-wishlist-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1 ? 'true' : 'false'); });
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
  }
  function initWishlist() {
    wlRefresh();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-wishlist-toggle]');
      if (!b) return;
      e.preventDefault();
      var h = b.getAttribute('data-wishlist-toggle');
      var list = wlGet();
      var idx = list.indexOf(h);
      if (idx > -1) list.splice(idx, 1); else list.push(h);
      wlSet(list);
      wlRefresh();
    });
    var grid = $('[data-wishlist-grid]');
    if (grid) {
      var list = wlGet();
      if (!list.length) { grid.innerHTML = '<p class="empty-state">' + grid.getAttribute('data-empty-text') + '</p>'; return; }
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (cards) {
        grid.innerHTML = cards.join('') || '<p class="empty-state">' + grid.getAttribute('data-empty-text') + '</p>';
        wlRefresh();
      });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var targets = $$('.section .section-head, .product-card, .tile, .values__item, .split__inner');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t) {
      // Only animate things below the fold, so nothing visible on load ever starts hidden
      if (t.getBoundingClientRect().top > window.innerHeight) { t.classList.add('reveal'); io.observe(t); }
    });
  }


  /* ---------- Scent quiz ---------- */
  function initQuiz() {
    $$('[data-quiz]').forEach(function (q) {
      if (q._ready) return; q._ready = true;
      var data = []; var copy = {};
      try { data = JSON.parse($('[data-quiz-products]', q).textContent); copy = JSON.parse($('[data-quiz-copy]', q).textContent); } catch (e) {}
      var intro = $('[data-quiz-intro]', q), form = $('[data-quiz-form]', q), result = $('[data-quiz-result]', q);
      var steps = $$('[data-step]', q), bar = $('[data-quiz-bar]', q), back = $('[data-quiz-back]', q), count = $('[data-quiz-count]', q);
      var cur = 0;
      function show(i) {
        cur = i;
        steps.forEach(function (s, idx) { s.hidden = idx !== i; });
        bar.style.width = ((i) / steps.length * 100) + '%';
        back.hidden = i === 0;
        count.textContent = (copy.step || '{n} / {t}').replace('{n}', i + 1).replace('{t}', steps.length);
        var first = $('input', steps[i]); if (first) first.focus({ preventScroll: true });
      }
      $('[data-quiz-start]', q).addEventListener('click', function () { intro.hidden = true; form.hidden = false; show(0); });
      back.addEventListener('click', function () { if (cur > 0) show(cur - 1); });
      form.addEventListener('change', function () {
        setTimeout(function () { if (cur < steps.length - 1) show(cur + 1); else finish(); }, 220);
      });
      $('[data-quiz-restart]', q).addEventListener('click', function () { form.reset(); result.hidden = true; form.hidden = false; show(0); });

      var MOOD = {
        calm: { 'floral-rose': 2, 'vanilla-gourmand': 2, 'fresh-clean': 1 },
        cosy: { 'oud-amber': 2, 'vanilla-gourmand': 2, 'woody-musk': 1 },
        fresh: { 'fresh-clean': 3, 'floral-rose': 1 },
        rich: { 'oud-amber': 3, 'woody-musk': 2 }
      };
      var ROOM_FORMAT = { living: 'Candles', bedroom: 'Candles', bathroom: 'Reed Diffusers', office: 'Reed Diffusers', gift: 'Candles' };

      function finish() {
        var a = Object.fromEntries(new FormData(form).entries());
        var w = Object.assign({}, MOOD[a.mood] || {});
        if (a.notes) w[a.notes] = (w[a.notes] || 0) + 3;
        if (a.room === 'bedroom') { w['floral-rose'] = (w['floral-rose'] || 0) + 1; w['vanilla-gourmand'] = (w['vanilla-gourmand'] || 0) + 1; }
        if (a.room === 'office') w['fresh-clean'] = (w['fresh-clean'] || 0) + 1;
        var fmt = a.format === 'any' || !a.format ? ROOM_FORMAT[a.room] || 'Candles' : a.format;
        var pool = data.filter(function (p) { return p.available && p.type === fmt; });
        if (!pool.length) pool = data.filter(function (p) { return p.available; });
        pool.forEach(function (p) {
          var ws = (p.families || []).map(function (f) { return w[f] || 0; });
          var mx = ws.length ? Math.max.apply(null, ws) : 0;
          var total = ws.reduce(function (a2, b2) { return a2 + b2; }, 0);
          p._s = mx + 0.25 * (total - mx);
          if (p.bestseller) p._s += a.room === 'gift' ? 2 : 0.5;
          if (p.families && p.families[0] === a.notes) p._s += 1;
        });
        pool.sort(function (x, y) { return y._s - x._s; });
        var picks = [], seen = {};
        pool.forEach(function (p) { if (picks.length < 3 && !seen[p.scent]) { seen[p.scent] = 1; picks.push(p); } });
        var top = picks[0];
        $('[data-result-title]', result).textContent = top ? (copy.match || 'Your match: {scent}').replace('{scent}', top.scent || top.title) : '';
        $('[data-result-why]', result).textContent = (copy[a.mood] || '') + (top && top.notes ? ' ' + top.notes + '.' : '');
        var grid = $('[data-result-grid]', result);
        grid.innerHTML = '';
        Promise.all(picks.map(function (p) {
          return fetch(root + 'products/' + encodeURIComponent(p.handle) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        })).then(function (cards) { grid.innerHTML = cards.join(''); wlRefresh(); });
        bar.style.width = '100%';
        form.hidden = true; result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ---------- Cart gift options ---------- */
  function initGiftOptions() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-gift-wrap]')) {
        var id = parseInt(t.getAttribute('data-gift-wrap'), 10);
        var line = parseInt(t.getAttribute('data-gift-line') || '0', 10);
        var req = t.checked
          ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: drawerSectionId }) })
          : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: 0, sections: drawerSectionId }) });
        req.then(function (r) { return r.json(); }).then(function (d) {
          if (d.sections) renderDrawer(d.sections[drawerSectionId]);
          return fetch(root + 'cart.js').then(function (r) { return r.json(); });
        }).then(function (c) { updateCount(c.item_count); }).catch(function () { toast(K.strings.error); });
      }
    });
    var timer;
    document.addEventListener('input', function (e) {
      if (!(e.target.matches && e.target.matches('[data-cart-note]'))) return;
      clearTimeout(timer);
      var v = e.target.value;
      timer = setTimeout(function () {
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
      }, 500);
    });
  }

  /* ---------- Newsletter pop-up ---------- */
  function initPopup() {
    var pop = $('[data-popup]');
    if (!pop) return;
    var key = 'kamaya-popup-seen';
    var close = function () { pop.hidden = true; try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
    $$('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    if (pop.hasAttribute('data-popup-success')) { pop.hidden = false; try { localStorage.setItem(key, String(Date.now())); } catch (e) {} return; }
    var seen = 0; try { seen = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    var days = parseInt(pop.getAttribute('data-popup-days') || '14', 10);
    if (seen && Date.now() - seen < days * 864e5) return;
    if (window.Shopify && Shopify.designMode && !pop.hasAttribute('data-popup-preview')) return;
    setTimeout(function () { pop.hidden = false; }, (parseInt(pop.getAttribute('data-popup-delay') || '8', 10)) * 1000);
  }

  function init() {
    initHeader();
    initAutosubmit();
    initSlideshows();
    initGallery();
    initProductForms();
    initCart();
    initWishlist();
    initReveal();
    initQuiz();
    initGiftOptions();
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initSlideshows(); initGallery(); initProductForms(); initQuiz(); wlRefresh(); });
})();
